import script from "./NewsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsEditor.vue?vue&type=script&setup=true&lang=js"

import "./NewsEditor.vue?vue&type=style&index=0&id=759326ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-759326ac"]])

export default __exports__